<a *ngIf="linkedModule !== undefined && linkedModule !== null" (click)="openModuleDetail()">
  <nz-space>
    <nz-space-item>
      <i nz-icon nzType="arrow-right" nzTheme="outline"></i>
    </nz-space-item>
    <nz-space-item>
      <span [innerHTML]="colData.Translatable ? (value | locale) : (value | safeHtml)">
      </span>
    </nz-space-item>
  </nz-space>
</a>
<span *ngIf="!(linkedModule !== undefined && linkedModule !== null)" [innerHTML]="colData.Translatable ? (value | locale) : (value | safeHtml)">
</span>
